import Vue from 'vue';

export default {
    successNotify(message, titleArg, iteration = 1) {
        const title = titleArg || 'Mentés sikeres!';
        const msg = message || 'Adatok mentése sikeresen megtörtént!';

        Vue.notify({
            group: 'notify',
            title,
            text: msg,
            duration: 7000 + iteration * 50,
            type: 'success',
        });
    },

    failureNotify(message = null, titleArg = null, iteration = 1) {
        const title = titleArg
            ? '<span style=\'font-size: 16px; font-weight: bold; color: rgb(255,251,0);\'>' + titleArg + '</span>'
            : '<span style=\'font-size: 16px; font-weight: bold; color: #ffcc00;\'>Mentés sikertelen!</span>';
        const msg = message
            ? '<span style=\'font-size: 16px; font-weight: bold;\'>' + message + '</span>'
            : '<span style=\'font-size: 16px; font-weight: bold;\'>Adatok mentése sikertelen!</span>';

        Vue.notify({
            group: 'notify',
            title,
            text: msg,
            duration: 7000 + iteration * 200,
            type: 'error',
        });
    },

    permanentNotify(message = null, titleArg = null, iteration = 1) {
        const title = titleArg
            ? '<span style=\'font-size: 16px; font-weight: bold; color: rgb(255,251,0);\'>' + titleArg + '</span>'
            : '<span style=\'font-size: 16px; font-weight: bold; color: #ffcc00;\'>Mentés sikertelen!</span>';
        const msg = message
            ? '<span style=\'font-size: 16px; font-weight: bold;\'>' + message + '</span>'
            : '<span style=\'font-size: 16px; font-weight: bold;\'>Adatok mentése sikertelen!</span>';

        Vue.notify({
            group: 'notify',
            title,
            text: msg,
            duration: 40000 + iteration * 200,
            type: 'error',
        });
    },
};
